<template>
  <div class="mod-dialog">
    <z-message-box size='address' @close="close" :show='show' noClose="" title="请填写收货人信息">
        <div class="addressForm">
            
                <div class="inputList fix">
                  <div class="leftTitle"><span class="starRed">*</span>姓名：</div>
                  <div class="inputText">
                    <z-input  size='260' :maxlength="20" v-model.trim="linkMan" placeholder="请输入收货人姓名"></z-input>
                  </div>
                  <div v-if="err.linkMan" class="inputText addr-err">{{ err.linkMan }}</div>
                </div>

                <div class="inputList fix">
                  <div class="leftTitle"><span class="starRed">*</span>手机：</div>
                  <div class="inputText">
                   <z-input  size='260'  :maxlength="11" v-model.trim="phone" placeholder="请输入手机号码"></z-input>
                  </div>
                  <div v-if="err.phone" class="inputText addr-err">{{ err.phone }}</div>
                </div>

                <div class="inputList fix">
                  <div class="leftTitle"><span class="starRed">*</span>地区：</div>
                  <div class="inputText">
                    <z-select size='280' :disabled="areas.length == 0" class="categories-middle" :zoptions='areas' v-model="Aareas" placeholder="请选择省"></z-select>
                  </div>
                  <div v-if="err.Aareas" class="inputText addr-err">{{ err.Aareas }}</div>
                </div>

                <div class="inputList fix">
                  <div class="leftTitle">&nbsp;</div>
                  <div class="inputText">
                    <z-select size='280' :disabled="region.length == 0" class="categories-middle" :zoptions='region' v-model="Bregion" placeholder="请选择市"></z-select>
                  </div>
                  <div v-if="err.Bregion" class="inputText addr-err">{{ err.Bregion }}</div>
                </div>
                <div class="inputList fix">
                  <div class="leftTitle">&nbsp;</div>
                  <div class="inputText">
                    <z-select size='280' :disabled="city.length == 0"  class="categories-middle" :zoptions='city' v-model="Ccity" placeholder="请选择区"></z-select>
                  </div>
                  <div v-if="err.Ccity" class="inputText addr-err">{{ err.Ccity }}</div>
                </div>

                <div class="inputList fix">
                  <div class="leftTitle">&nbsp;</div>
                  <div class="inputText">
                    <z-input type="textarea" size='282' :maxlength="100" v-model.trim="address" placeholder="建议您如实填写详细收货地址，例如街道名称，门牌号码，楼层和房间号等信息"></z-input>
                  </div>
                  <div v-if="err.address" class="inputText addr-err">{{ err.address }}</div>
                </div>

                <div class="option">
                  <z-button  @click="clickDefault(0)">设为默认地址并保存</z-button>
                  <z-button  @click="clickDefault(1)" class="ml20" size='primary'>保存</z-button>
                </div>
         
            </div>

      </z-message-box>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ZMessageBox from "./message-box";
import ZInput from "./zInput";
import ZSelect from "./zSelect";
import ZButton from "./zButton";

export default {
  name: "Top",
  props: {
    show: "",
    item: ""
  },
  data() {
    return {
      linkMan: "",
      phone: "",
      Aareas: "",
      Bregion: "",
      Ccity: "",
      address: "",
      err: {
        linkMan: "",
        phone: "",
        Aareas: "",
        Bregion: "",
        Ccity: "",
        address: ""
      }
    };
  },
  computed: {
    ...mapGetters(["adrList", "areas", "region", "city"])
  },
  components: {
    ZMessageBox,
    ZInput,
    ZButton,
    ZSelect
  },
  created() {},
  watch: {
    show(val) {
      if (val == false) return;
      this.$store.dispatch("AREAS");
      if (this.item == "") {
        this.linkMan = "";
        this.phone = "";
        this.address = "";
        this.Aareas = "";
        this.Bregion = "";
        this.Ccity = "";
        this.$store.commit("REGION", []);
        this.$store.commit("CITY", []);
      } else {
        this.linkMan = this.item.linkMan;
        this.phone = this.item.phone;
        this.address = this.item.address;
        this.Aareas = {
          name: this.item.provinceName,
          id: this.item.provinceCode
        };
        this.Bregion = { name: this.item.cityName, id: this.item.cityCode };
        this.Ccity = {
          name: this.item.districtName,
          id: this.item.districtCode
        };

        // this.$store.dispatch("REGION", this.item.provinceCode);
        // this.$store.dispatch("CITY", {
        //   regionId: this.item.provinceCode,
        //   cityId: this.item.cityCode
        // });
      }
    },
    Aareas(val) {
      this.$store.commit("REGION", []);
      this.$store.commit("CITY", []);
      if (val.is) {
        this.Bregion = "";
        this.Ccity = "";
      }
      this.$store.dispatch("REGION", val.id);
    },
    Bregion(val) {
      this.$store.commit("CITY", []);
      if (val.is) {
        this.Ccity = "";
      }
      this.$store.dispatch("CITY", {
        regionId: this.Aareas.id,
        cityId: val.id
      });
    }
  },
  methods: {
    close() {
      this.$emit("addrOk", false);
    },
    clickDefault(isDefault) {
      var self = this;
      const o = {
        address: this.address,
        isDefault: this.item != '' && isDefault == 1 ? this.item.isDefault : isDefault, // 是否为默认，0：默认；1：不默认
        linkMan: this.linkMan, // 联系人
        provinceCode: this.Aareas.id, // 省编号
        cityCode: this.Bregion.id, // 市编号
        districtCode: this.Ccity.id, // 区编号
        phone: this.phone // 手机号码
      };

      if (this.linkMan == "") {
        this.err.linkMan = "姓名不能为空";
      } else if (!new RegExp(self.$conf.REG.LINKMAN).test(this.linkMan)) {
        this.err.linkMan = "字符格式不正确";
      } else {
        this.err.linkMan = "";
      }

      if (this.phone == "") { 
        this.err.phone = "号码不能为空";
      } else if (!new RegExp(self.$conf.REG.MOBILE).test(this.phone)) {
        this.err.phone = "号码格式不正确";
      } else {
        this.err.phone = "";
      }

      if (this.Aareas == "" || this.Aareas == undefined) {
        this.err.Aareas = "请选择省份";
      } else {
        this.err.Aareas = "";
      }

      if (this.Bregion == "") {
        this.err.Bregion = "请选择城市";
      } else {
        this.err.Bregion = "";
      }

      if (this.Ccity == "") {
        this.err.Ccity = "请选择区/镇";
      } else {
        this.err.Ccity = "";
      }

      if (this.address == "") {
        this.err.address = "地址不能为空";
      } else if (!new RegExp(self.$conf.REG.ADDRESS).test(this.address)) {
        this.err.address = "字符格式不正确";
      } else {
        this.err.address = "";
      }

      if (
        o.address == "" ||
        o.linkMan == "" ||
        o.provinceCode == "" ||
        o.provinceCode == undefined ||
        o.cityCode == "" ||
        o.cityCode == undefined ||
        o.districtCode == "" ||
        o.districtCode == undefined ||
        o.phone == "" || 
        !new RegExp(self.$conf.REG.LINKMAN).test(this.linkMan) || 
        !new RegExp(self.$conf.REG.MOBILE).test(this.phone) ||
        !new RegExp(self.$conf.REG.ADDRESS).test(this.address)
      )
        return;

      if (this.item == "") {
        this.$store.dispatch("ADD_DEFAULT", o).then(r => {
          if (r.data.recode == 200) {
            self.$emit("addrOk", true);
            self.$store.dispatch("ADDRLIST");
          } else {
            self.$message.error(r.data.msg || '错误：' + r.data.recode);
          }
        });
      } else {
        o.id = this.item.id;
        this.$store.dispatch("PUT_ADDR", o).then(r => {
          if (r.data.recode == 200) {
            self.$emit("addrOk", true);
            self.$store.dispatch("ADDRLIST");
          }
        });
      }
    }
  }
};
</script>
<style>
.addressForm {
  margin-top: 20px;
}
.inputList {
  width: 100%;
  line-height: 34px;
  padding-bottom: 15px;
}
.leftTitle {
  float: left;
  width: 130px;
  text-align: right;
  font-size: 14px;
}
.leftTitle .starRed {
  padding-right: 3px;
  font-family: "宋体";
  color: #d01126;
}
.inputList .inputText {
  float: left;
  position: relative;
}
.inputList .inputText textarea{
  height: 100px;
}
.addr-err {
  text-align: right;
  color: #ed6c00;
  font-size: 12px;
  margin-left: 15px;
}
</style>
